const hasLineItemTypes = (lineItems, producTypes) => lineItems.some((item) => producTypes?.includes(item.type));
export {
  hasLineItemTypes
};
//# sourceMappingURL=has-line-item-types.js.map
